import { createEventNameProxy } from "@hesxenon/prelude/Dom.js";

export const Events = createEventNameProxy<
  UwcDatepickerElement,
  ["afterViewInit", "drillUp"]
>();
